import React from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar } from 'reactstrap';
import PrintTripExpenseButton from './PrintTripExpenseButton';

const DetractionToolbar = ({ detractionId }) => (
  <ButtonToolbar className="pull-right">
    <div>
      <PrintTripExpenseButton parcel={detractionId}/>
    </div>
  </ButtonToolbar>
);

DetractionToolbar.propTypes = {
  detractionId: PropTypes.number.isRequired,
};

export default DetractionToolbar;
